export default __webpack_public_path__ + "static/ratna-sosialin-35261457f351625a99a10a39dfafe6d2.webp";